import { useTranslation } from 'react-i18next';

import { AccessoryTabProps } from 'components/desktop/Accessory/AccessoryComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import TreeInput from 'components/desktop/_general/Input/TreeInput/TreeInput';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';
import { useApi } from 'hooks/useApi';
import * as CategoryTree from 'types/Accessory/Detail/CategoryTree';

export const AccessoryCategoriesCard = ({ state, handlers }: AccessoryTabProps): JSX.Element => {
	const { t } = useTranslation();

	const [categoryTree] = useApi<CategoryTree.Type[], string>([], CategoryTree.getFromApi, '');

	const isAccessoryEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEACCESSORY,
	]);

	const getLabelCategories = (): string => {
		if (!isAccessoryEditor) {
			if (state.categories) {
				if (state.categories.length === 0) {
					return t('_general:NO_CATEGORIES');
				}
			}
			return '';
		}
		return t('_general:CATEGORIES');
	};

	const getSelectedCategoriesTree = (): CategoryTree.Type[] => {
		if (!state.categories) return [];
		const output: CategoryTree.Type[] = [];
		for (const i of state.categories) {
			const element: CategoryTree.Type | undefined = findElementInTree(i.id, categoryTree);
			if (element) {
				output.push(element);
			}
		}
		return output;
	};

	const findElementInTree = (
		id: string,
		tree: CategoryTree.Type[]
	): CategoryTree.Type | undefined => {
		for (const i of tree) {
			if (i.id === id) return i;
			for (const child of i.children) {
				const found = findElementInTree(id, [child]);
				if (found) return found;
			}
		}
		return undefined;
	};

	return (
		<FoldableCard
			dataComponentType="accessory-categories-card"
			defaultOpen={true}
			title={t('_general:CATEGORIES')}
			content={
				<div className="card-body">
					<TreeInput
						input={categoryTree}
						setSelected={handlers.setCategories}
						selected={getSelectedCategoriesTree()}
						errorKey="Categories"
						disabled={!isAccessoryEditor}
						label={getLabelCategories()}
						noObjectsFoundText={t('_general:NO_CATEGORIES')}
					/>
				</div>
			}
		/>
	);
};
